import React from "react";

const Heart = ({ size = 20, color = "#000", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size * 0.9}
    fill="none"
    {...props}
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="m12.025 3.025-1.318 1.318a1 1 0 0 1-1.414 0L7.975 3.025a3.5 3.5 0 1 0-4.95 4.95L10 14.95l6.975-6.975.707.707-.707-.707a3.5 3.5 0 0 0-4.95-4.95Zm-1.414-1.414a5.5 5.5 0 0 1 7.778 7.778l-7.682 7.682a1 1 0 0 1-1.414 0L1.61 9.39a5.5 5.5 0 0 1 7.778-7.778l.611.61.61-.61Z"
      clipRule="evenodd"
    />
  </svg>
);

export default Heart;
